import { render, staticRenderFns } from "./SettingsAutoprocessing.vue?vue&type=template&id=0a1e8528&"
import script from "./SettingsAutoprocessing.vue?vue&type=script&lang=js&"
export * from "./SettingsAutoprocessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports